import LendoIcon from './LendoIcon';

export default function LendoFooterSocials() {
  return (
    <div className="socials">
      <div className="socials__follow-text">Følg oss</div>
      <div className="lendo-socials__item">
        <a
          href="https://www.facebook.com/LendoNorge"
          title="Facebook"
          aria-label="Åpne siden til Facebook"
          rel="noopener"
          target="_blank"
        >
          <LendoIcon name="icon/facebook" size="24px" />
        </a>
      </div>
      <div className="lendo-socials__item">
        <a
          href="https://www.instagram.com/lendonorge/"
          title="Instagram"
          aria-label="Åpne siden til Instagram"
          rel="noopener"
          target="_blank"
        >
          <LendoIcon name="icon/instagram" size="24px" />
        </a>
      </div>
      <div className="lendo-socials__item">
        <a
          href="https://www.youtube.com/@LendoNorge"
          title="Youtube"
          aria-label="Åpne siden til Youtube"
          rel="noopener"
          target="_blank"
        >
          <LendoIcon name="icon/youtube" size="24px" />
        </a>
      </div>
    </div>
  );
}
